import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommandService, CommandTemplate, Reloadable } from '@nexato/nx-core-module';
import { MenuItem } from 'primeng/api';
import { ContactPerson } from 'src/app/rent-module/shared/entities/contactPerson/contactPerson';
import { LineItem } from 'src/app/rent-module/shared/entities/lineItem/lineItem';
import { ResourceAssignment } from 'src/app/rent-module/shared/entities/resourceAssignment/resourceAssignment';

@Component({
  selector: 'app-order-operated-rental-line-items',
  templateUrl: './order-operated-rental-line-items.component.html',
  styleUrls: ['./order-operated-rental-line-items.component.scss']
})
export class OrderOperatedRentalLineItemsComponent implements Reloadable {

  @Output() refetch = new EventEmitter();
  @Input() public lineItems: LineItem[];
  @Input() orderId: string;

  defaultColumns = [
    'dueDateTimePeriod',
    'extendedState'
  ];

  constructor(public datePipe: DatePipe,
    public commandService: CommandService) {

  }

  reload(): void {
    this.refetch.emit();
  }

  getAvailableMenuItems(resourceAssignment: ResourceAssignment): MenuItem[] {
    let menuItems: MenuItem[] = [];

    if (resourceAssignment?.commands?.length > 0) {
      resourceAssignment?.commands.forEach((command: CommandTemplate) => {
        menuItems.push({
          label: command.settings?.label,
          disabled: command.settings?.disabled,
          command: () => {
            this.commandService.execute(resourceAssignment, command, this);
          }
        });
      });
    }

    return menuItems;
  }

  getName(contacts: ContactPerson[]): string {
    if (!contacts) {
      return undefined;
    }
    let name = undefined;
    for (let contact of contacts) {
      const fullName = contact?.getFullName();
      if (fullName) {
        name = name ? name + ', ' + fullName : fullName;
      }
    }
    return name ? name : '-';
  }

}
